import { render, staticRenderFns } from "./UpdateWheelLock.vue?vue&type=template&id=df7d4704&"
import script from "./UpdateWheelLock.vue?vue&type=script&lang=js&"
export * from "./UpdateWheelLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports